import { MainContentPanel } from '../components/MainContentPanel';
import { GET_USERS_WITH_HIGH_USAGE } from './reports.graphql';
import { useQuery } from '@apollo/client/react';
import LoadingSpinner from '../components/LoadingSpinner';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { WidgetTitle } from '../dashboard/WidgetTitle';
import { useState } from 'react';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { nbNO } from '@mui/x-data-grid/locales';

interface User {
  userId: string;
  name: string;
  licenseId: string;
  companyName: string;
  views: string;
}

export function UserPageViews(props) {
  const [monthOffset, setMonthOffset] = useState(Number(props.offset));

  var take = 100;

  const { loading, data } = useQuery<any, any>(GET_USERS_WITH_HIGH_USAGE, { variables: { monthOffset: monthOffset, take: take }, fetchPolicy: 'network-only' });

  return (
    <>
      <Grid container>
        <Grid size={5}>
          <WidgetTitle
            title="Brukeraktivitet for"
            offset={monthOffset}
            stateSetter={(step) => {
              setMonthOffset(monthOffset + step);
            }}
            displayYear={true}
            forwardLimit={1}
          />

          {loading && <LoadingSpinner />}
          {!loading && !data && <div>Mangler data</div>}
          {data && renderDetails(data.users)}
        </Grid>
      </Grid>
    </>
  );

  function renderDetails(users) {
    const rows = users.map((user: User) => ({
      id: user.userId,
      userId: user.userId,
      name: user.name,
      licenseId: user.licenseId,
      companyName: user.companyName,
      views: user.views,
    }));

    const columns: GridColDef<(typeof rows)[number]>[] = [
      {
        field: 'name',
        headerName: 'Navn',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => <Link to={`/user/${params.row.userId}`}>{params.row.name}</Link>,
      },
      {
        field: 'companyName',
        headerName: 'Firma',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
        renderCell: (params) => <Link to={`/license/${params.row.licenseId}`}>{params.row.companyName}</Link>,
      },
      {
        field: 'views',
        headerName: 'Antall sidevisninger',
        minWidth: 160,
        flex: 1,
        align: 'left',
        headerAlign: 'left',
      },
    ];

    return (
      <DataGridPro
        autoHeight
        density="compact"
        rows={rows}
        columns={columns}
        localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
        pagination
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
              page: 0,
            },
          },
        }}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 700,
          },
        }}
      />
    );
  }
}
